(function () {
    'use strict';

    var ROOT_SELECTOR = '[data-hatchill-app-offer-root]';
    var AUTO_PANEL_SESSION_KEY = 'hatchill_app10_timed_panel_seen_v4';
    var PURCHASE_INTERACTED_KEY = 'hatchill_app10_pdp_purchase_interacted';
    var SEEN_THIS_SESSION_KEY = 'hatchill_app_conversion_seen';
    var STORE_CLICKED_AT_KEY = 'hatchill_app_conversion_store_clicked_at';
    var APP_OPEN_FALLBACK_MS = 1100;
    var MOBILE_QUERY = '(max-width: 767px)';

    function ensureHatchillModalCoordinator() {
      var existing = window.HatchillModalCoordinator;
      if (existing && typeof existing.reserve === 'function' && typeof existing.release === 'function') return existing;
      var owner = null;
      var coordinator = {
        reserve: function (nextOwner) {
          if (!owner || owner === nextOwner) { owner = nextOwner; return true; }
          return false;
        },
        release: function (currentOwner) {
          if (owner === currentOwner) owner = null;
        },
        isReservedByOther: function (currentOwner) { return Boolean(owner && owner !== currentOwner); },
        currentOwner: function () { return owner; }
      };
      window.HatchillModalCoordinator = coordinator;
      return coordinator;
    }

    function hasRenderedModalSurface(excludedRoot) {
      var visitedRoots = new WeakSet();
      var modalSelector = 'dialog[open], [role="dialog"][aria-modal="true"], [data-hatchill-app-sheet]:not([hidden])';

      function rendered(element) {
        if (!element || (excludedRoot && (element === excludedRoot || excludedRoot.contains(element)))) return false;
        if (element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
        var styles = window.getComputedStyle(element);
        var rect = element.getBoundingClientRect();
        return styles.display !== 'none' && styles.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      }

      function inspect(root) {
        if (!root || visitedRoots.has(root)) return false;
        visitedRoots.add(root);
        if (root.querySelectorAll) {
          var candidates = root.querySelectorAll(modalSelector);
          for (var index = 0; index < candidates.length; index += 1) {
            if (rendered(candidates[index])) return true;
          }
          var elements = root.querySelectorAll('*');
          for (var elementIndex = 0; elementIndex < elements.length; elementIndex += 1) {
            var shadowRoot = elements[elementIndex].shadowRoot;
            if (shadowRoot && inspect(shadowRoot)) return true;
          }
        }
        return false;
      }

      return inspect(document);
    }

    function initAll(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      var roots = [];
      if (context.matches && context.matches(ROOT_SELECTOR)) roots.push(context);
      roots = roots.concat(Array.prototype.slice.call(context.querySelectorAll(ROOT_SELECTOR)));
      roots.forEach(init);
    }

    function init(root) {
      if (!root || root.dataset.hatchillAppOfferInitialized === 'true') return;
      root.dataset.hatchillAppOfferInitialized = 'true';

      var teaser = root.querySelector('[data-hatchill-app-teaser]');
      var sheet = root.querySelector('[data-hatchill-app-sheet]');
      var panel = root.querySelector('[data-hatchill-app-sheet-panel]');
      var backdrop = root.querySelector('[data-hatchill-app-sheet-backdrop]');
      var closeButton = root.querySelector('[data-hatchill-app-sheet-close]');
      var appCtas = Array.prototype.slice.call(root.querySelectorAll('[data-hatchill-app-cta]'));
      var mobileMedia = window.matchMedia(MOBILE_QUERY);
      var reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
      var productScope = root.closest('product-information, .product-information, section') || document;
      var teaserViewed = false;
      var panelOpen = false;
      var panelClosing = false;
      var openedAt = 0;
      var previouslyFocused = null;
      var pendingFallback = null;
      var closeTimer = null;
      var teaserObserver = null;
      var sheetHome = null;
      var sheetNextSibling = null;
      var inertedElements = [];
      var modalCoordinator = ensureHatchillModalCoordinator();

      if (!teaser || !sheet || !panel || !closeButton || !appCtas.length) return;
      sheetHome = sheet.parentNode;
      sheetNextSibling = sheet.nextSibling;

      function sessionGet(key) {
        try {
          return window.sessionStorage.getItem(key);
        } catch (error) {
          return null;
        }
      }

      function sessionSet(key, value) {
        try {
          window.sessionStorage.setItem(key, value);
        } catch (error) {
          return;
        }
      }

      function localSet(key, value) {
        try {
          window.localStorage.setItem(key, value);
        } catch (error) {
          return;
        }
      }

      function platform() {
        var userAgent = window.navigator.userAgent || '';
        if (/android/i.test(userAgent)) return 'android';
        if (/iPad|iPhone|iPod/.test(userAgent) || (/Macintosh/.test(userAgent) && window.navigator.maxTouchPoints > 1)) return 'ios';
        return 'web';
      }

      function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          var parser = document.createElement('div');
          parser.innerHTML = window.Shopify.formatMoney(cents, window.money_format);
          return parser.textContent || '';
        }
        return String((cents / 100).toFixed(2));
      }

      function offerPayload(extra) {
        var payload = {
          commercial_attribution_status: 'pending_app_order_linkage',
          offer_code: 'APP10',
          product_handle: root.dataset.productHandle || '',
          variant_id: root.dataset.variantId || '',
          original_price: Number(root.dataset.appOriginalPrice || 0),
          app_price: Number(root.dataset.appPrice || 0),
          estimated_savings: Number(root.dataset.appSavings || 0),
          placement: 'pdp_app10_teaser',
          platform: platform(),
          locale: document.documentElement.lang || '',
          direction: document.documentElement.dir || window.getComputedStyle(document.documentElement).direction,
          creative_version: root.dataset.creativeVersion || 'app10-premium-card-v5'
        };
        if (extra) Object.keys(extra).forEach(function (key) { payload[key] = extra[key]; });
        return payload;
      }

      function track(name, extra) {
        var payload = offerPayload(extra);
        if (window.HatchillEvents && typeof window.HatchillEvents.track === 'function') {
          window.HatchillEvents.track(name, payload);
        }
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          var published = window.Shopify.analytics.publish('hatchill:' + name, payload);
          if (published && typeof published.catch === 'function') published.catch(function () {});
        }
      }

      function offerElements(selector) {
        var elements = Array.prototype.slice.call(root.querySelectorAll(selector));
        if (!root.contains(sheet)) {
          elements = elements.concat(Array.prototype.slice.call(sheet.querySelectorAll(selector)));
        }
        return elements;
      }

      function updateOffer(nextVariant) {
        if (!nextVariant || typeof nextVariant.price === 'undefined') return;
        var originalPrice = Number(nextVariant.price || 0);
        var appPrice = Math.floor(originalPrice * 0.9);
        var savings = originalPrice - appPrice;
        var available = nextVariant.available !== false && originalPrice > 0;

        root.dataset.variantId = String(nextVariant.id || '');
        root.dataset.appOriginalPrice = String(originalPrice);
        root.dataset.appPrice = String(appPrice);
        root.dataset.appSavings = String(savings);
        root.dataset.offerAvailable = String(available);

        offerElements('[data-app-original-price-output]').forEach(function (output) {
          output.textContent = formatMoney(originalPrice);
        });
        offerElements('[data-app-price-output]').forEach(function (output) {
          output.textContent = formatMoney(appPrice);
        });
        offerElements('[data-app-saving-output]').forEach(function (output) {
          output.textContent = (output.dataset.savingTemplate || '__AMOUNT__').replace('__AMOUNT__', formatMoney(savings));
        });

        if (!available && panelOpen) closePanel('variant_unavailable', false);
      }

      function anotherDialogIsOpen() {
        return hasRenderedModalSurface(sheet);
      }

      function getFocusableElements() {
        return Array.prototype.slice.call(
          sheet.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
        ).filter(function (element) {
          return element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true';
        });
      }

      function portalSheet(shouldPortal) {
        if (shouldPortal) {
          if (sheet.parentNode !== document.body) {
            sheetHome = sheet.parentNode;
            sheetNextSibling = sheet.nextSibling;
            document.body.appendChild(sheet);
          }
          return;
        }
        if (!sheetHome || !document.documentElement.contains(sheetHome)) {
          if (sheet.parentNode === document.body) sheet.remove();
          return;
        }
        if (sheetNextSibling && sheetNextSibling.parentNode === sheetHome) {
          sheetHome.insertBefore(sheet, sheetNextSibling);
        } else {
          sheetHome.appendChild(sheet);
        }
      }

      function setBackgroundInert(shouldInert) {
        if (!window.HTMLElement || !('inert' in window.HTMLElement.prototype)) return;
        if (!shouldInert) {
          inertedElements.forEach(function (element) { element.inert = false; });
          inertedElements = [];
          return;
        }
        Array.prototype.forEach.call(document.body.children, function (element) {
          if (element === sheet || element.inert || /^(SCRIPT|STYLE|LINK)$/.test(element.tagName)) return;
          element.inert = true;
          inertedElements.push(element);
        });
      }

      function handlePanelKeydown(event) {
        if (!panelOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          closePanel('escape', true);
          return;
        }
        if (event.key !== 'Tab') return;
        var focusable = getFocusableElements();
        if (!focusable.length) {
          event.preventDefault();
          sheet.focus({ preventScroll: true });
          return;
        }
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      function openPanel(trigger) {
        if (panelOpen || panelClosing || !mobileMedia.matches || root.dataset.offerAvailable === 'false') return false;
        if (!modalCoordinator.reserve('app10')) return false;
        if (hasRenderedModalSurface(sheet)) { modalCoordinator.release('app10'); return false; }
        panelOpen = true;
        openedAt = Date.now();
        previouslyFocused = document.activeElement;
        if (!previouslyFocused || previouslyFocused === document.body || previouslyFocused === document.documentElement) {
          previouslyFocused = teaser;
        }
        sessionSet(SEEN_THIS_SESSION_KEY, '1');
        portalSheet(true);
        sheet.hidden = false;
        document.documentElement.classList.add('has-hatchill-pdp-app-panel');
        setBackgroundInert(true);
        document.addEventListener('keydown', handlePanelKeydown);
        window.requestAnimationFrame(function () {
          sheet.classList.add('is-visible');
        });
        window.setTimeout(function () {
          closeButton.focus({ preventScroll: true });
        }, reducedMotionMedia.matches ? 0 : 40);
        track('app_offer_panel_opened', { placement: 'pdp_app10_panel', trigger: trigger || 'timer_10s' });
        return true;
      }

      function closePanel(method, recordDismissal, immediate) {
        if ((!panelOpen && sheet.hidden) || (panelClosing && !immediate)) return;
        if (panelClosing && immediate) {
          window.clearTimeout(closeTimer);
          panelClosing = false;
        }
        panelOpen = false;
        panelClosing = true;
        sheet.classList.remove('is-visible');
        document.removeEventListener('keydown', handlePanelKeydown);
        if (recordDismissal) {
          track('app_offer_panel_dismissed', {
            placement: 'pdp_app10_panel',
            dismissal_method: method,
            time_open_ms: Math.max(0, Date.now() - openedAt)
          });
        }
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          sheet.hidden = true;
          panelClosing = false;
          document.documentElement.classList.remove('has-hatchill-pdp-app-panel');
          setBackgroundInert(false);
          portalSheet(false);
          modalCoordinator.release('app10');
          if (previouslyFocused && document.documentElement.contains(previouslyFocused)) {
            previouslyFocused.focus({ preventScroll: true });
          } else {
            teaser.focus({ preventScroll: true });
          }
          previouslyFocused = null;
        }, immediate || reducedMotionMedia.matches ? 0 : 220);
      }

      function handleMobileChange(event) {
        if (event.matches) {
          return;
        }
        if (panelOpen || panelClosing) closePanel('viewport_change', false, true);
      }

      function appendVariant(url) {
        if (!url) return '';
        var separator = url.indexOf('?') === -1 ? '?' : '&';
        return url + separator + 'utm_content=' + encodeURIComponent('variant_' + (root.dataset.variantId || 'unknown'));
      }

      function cancelFallback() {
        if (pendingFallback) window.clearTimeout(pendingFallback);
        pendingFallback = null;
      }

      function handleAppCta(event) {
        event.preventDefault();
        var sourcePlacement = event.currentTarget.dataset.sourcePlacement || 'pdp_app10_panel';
        var destinationPlatform = platform();
        var fallbackLink = appendVariant(root.dataset.appFallbackLink || event.currentTarget.href);
        var deepLink = appendVariant(root.dataset.appDeepLink);
        sessionSet(SEEN_THIS_SESSION_KEY, '1');
        sessionSet(AUTO_PANEL_SESSION_KEY, '1');
        localSet(STORE_CLICKED_AT_KEY, String(Date.now()));
        cancelFallback();
        track('app_offer_clicked', {
          placement: sourcePlacement,
          destination: destinationPlatform === 'web' || !deepLink ? 'smart_download' : 'app_deep_link'
        });

        if (destinationPlatform === 'web' || !deepLink) {
          window.location.assign(fallbackLink);
          return;
        }

        var cancelOnHide = function () {
          if (document.visibilityState !== 'visible') cancelFallback();
        };
        document.addEventListener('visibilitychange', cancelOnHide, { once: true });
        window.addEventListener('pagehide', cancelFallback, { once: true });
        pendingFallback = window.setTimeout(function () {
          pendingFallback = null;
          if (document.visibilityState === 'visible') {
            track('app_offer_store_fallback', { placement: sourcePlacement, destination: 'smart_download' });
            window.location.assign(fallbackLink);
          }
        }, APP_OPEN_FALLBACK_MS);
        window.location.assign(deepLink);
      }

      function handleVariantUpdate(event) {
        var nextVariant = event.detail && event.detail.resource;
        var sourceId = event.detail && event.detail.sourceId;
        var source = sourceId ? document.getElementById(sourceId) : null;
        if (!nextVariant) return;
        if (source && productScope !== document && !productScope.contains(source) && !source.contains(root)) return;
        updateOffer(nextVariant);
      }

      function handlePurchaseInteraction(event) {
        var target = event.target && event.target.closest
          ? event.target.closest('button[name="add"], [data-add-to-cart], .product-form__submit')
          : null;
        if (!target) return;
        track('app_offer_website_purchase_started', {
          placement: 'pdp_buy_buttons',
          trigger: 'add_to_cart',
          offer_state: panelOpen ? 'panel_open' : 'closed'
        });
        sessionSet(PURCHASE_INTERACTED_KEY, '1');
        if (panelOpen) closePanel('purchase_interaction', false);
      }

      function trackTeaserView() {
        if (teaserViewed || !mobileMedia.matches) return;
        teaserViewed = true;
        track('app_offer_teaser_viewed', { placement: 'pdp_app10_teaser', trigger: 'intersection' });
      }

      if (window.IntersectionObserver) {
        teaserObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
              trackTeaserView();
              teaserObserver.disconnect();
            }
          });
        }, { threshold: [0.45] });
        teaserObserver.observe(teaser);
      } else if (mobileMedia.matches) {
        trackTeaserView();
      }

      closeButton.addEventListener('click', function () { closePanel('close_button', true); });
      backdrop.addEventListener('click', function () { closePanel('backdrop', true); });
      appCtas.forEach(function (appCta) { appCta.addEventListener('click', handleAppCta); });
      document.addEventListener('variant:update', handleVariantUpdate);
      document.addEventListener('click', handlePurchaseInteraction);
      if (mobileMedia.addEventListener) mobileMedia.addEventListener('change', handleMobileChange);
      else if (mobileMedia.addListener) mobileMedia.addListener(handleMobileChange);
      root.hatchillAppOfferOpenPanel = openPanel;

      root.hatchillAppOfferCleanup = function () {
        window.clearTimeout(closeTimer);
        cancelFallback();
        if (teaserObserver) teaserObserver.disconnect();
        document.removeEventListener('variant:update', handleVariantUpdate);
        document.removeEventListener('click', handlePurchaseInteraction);
        document.removeEventListener('keydown', handlePanelKeydown);
        appCtas.forEach(function (appCta) { appCta.removeEventListener('click', handleAppCta); });
        if (mobileMedia.removeEventListener) mobileMedia.removeEventListener('change', handleMobileChange);
        else if (mobileMedia.removeListener) mobileMedia.removeListener(handleMobileChange);
        delete root.hatchillAppOfferOpenPanel;
        modalCoordinator.release('app10');
        if (panelOpen || panelClosing) {
          sheet.hidden = true;
          sheet.classList.remove('is-visible');
          document.documentElement.classList.remove('has-hatchill-pdp-app-panel');
          setBackgroundInert(false);
          portalSheet(false);
        }
      };
    }

    function handleSectionUnload(event) {
      var roots = [];
      if (event.target.matches && event.target.matches(ROOT_SELECTOR)) roots.push(event.target);
      if (event.target.querySelectorAll) {
        roots = roots.concat(Array.prototype.slice.call(event.target.querySelectorAll(ROOT_SELECTOR)));
      }
      roots.forEach(function (root) {
        if (root.hatchillAppOfferCleanup) root.hatchillAppOfferCleanup();
      });
    }

    if (window.HatchillAppOfferV4Booted) {
      if (window.HatchillAppOfferV4Init) window.HatchillAppOfferV4Init(document);
      return;
    }
    window.HatchillAppOfferV4Booted = true;
    window.HatchillAppOfferV4Init = initAll;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:section:unload', handleSectionUnload);
  })();
